{
    "TargetreportformatLabel": "Target Report Format:",
    "TargetreportformatPdfOptionLabel": "PDF Document",
    "TargetreportformatRtfOptionLabel": "RTF Document",
    "TargetreportformatCsvOptionLabel": "CSV Export",
    "TargetreportformatXlsOptionLabel": "XLS Export",
    "UselanguageLabel": "Use Language:",
    "UselanguageEnusOptionLabel": "English (United States)",
    "UselanguageEngbOptionLabel": "English (United Kingdom)",
    "PapersizeLabel": "Paper Size:",
    "PapersizeA4OptionLabel": "A4 (210mm x 297mm)",
    "PapersizeLegalOptionLabel": "Legal (8\\u00bd\" x 14\")",
    "PapersizeLetterOptionLabel": "Letter (8\\u00bd\" x 11\")",
    "NAME": "Format",
    "Format_SectionHeader": "Format"
}